import styled from 'styled-components'

import { ReactComponent as StarSvg } from '@sketch/icons/star-17'

export const StarIcon = styled(StarSvg)`
  width: 36px;
  height: 36px;
`
